module.exports = __webpack_public_path__ + "static/img/ios-download.ecc74ae7.png";